import * as preact from 'preact'
const { h, Component } = preact
import * as styles from './style.css'
import classNames from 'classnames'
import PureComponent from '../../lib/preact-pure-component'
import { testReducedMotion } from '@nrk/feature-tests'

interface Props {
  animationData: any
  className?: string
  startFrame?: number
  stopFrame?: number
  play: boolean
}

export class Lottie extends PureComponent<Props, {}> {
  el?: HTMLDivElement
  lottieplayer?: any
  animation?: any

  componentDidMount() {
    if (typeof window !== 'undefined') {
      this.mount()

      if (this.props.play) {
        this.play()
      }
    }
  }

  componentWillUnmount() {
    if (typeof window !== 'undefined') {
      this.unmount()
      this.el = undefined
    }
  }

  componentDidUpdate(prevProps: Props) {
    if (typeof window !== 'undefined') {
      if (!prevProps.play && this.props.play) {
        this.play()
      } else if (prevProps.play && !this.props.play) {
        this.stop()
      }
    }
  }

  mount = () => {
    this.lottieplayer = require('lottie-web/build/player/lottie_light')
    this.animation = this.lottieplayer.loadAnimation({
      container: this.el,
      renderer: 'svg',
      loop: true,
      autoplay: false,
      animationData: this.props.animationData
    })
    this.animation.addEventListener('DOMLoaded', this.props.loaded)
  }

  unmount = () => {
    this.animation.destroy()
    this.lottieplayer = undefined
  }

  play = () => {
    const { startFrame, stopFrame } = this.props
    if (!testReducedMotion()) {
      if (startFrame !== undefined && stopFrame !== undefined) {
        this.animation.playSegments([startFrame, stopFrame], true)
      } else {
        this.animation.play()
      }
    }
  }

  stop = () => {
    this.animation.stop()
  }

  render() {
    return <div className={this.props.className} ref={el => (this.el = el)} />
  }
}
